import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { CircularProgress, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DialogType } from 'commons/Dialog/CustomDialog';
import CustomIcon from 'commons/Icon/CustomIcon';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import { useDialog } from 'hook/DialogProvider';
import { useUserInfo } from 'hook/UseUserInfo';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UserService } from 'services/UserService';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { ErrorName } from 'utils/constants/error.name';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    height: 40,
    bottom: 60,
    right: 30,
    display: 'flex',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
    alignItems: 'center',
    boxShadow: theme.palette.shadow.hover,
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      right: 0,
      padding: theme.spacing(1)
    }
  },
  exitButton: {
    color: theme.palette.error.dark
  }
}));

const ImpersonatingUserOverlay = () => {
  const { firstName, lastName, personNumber } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const classes = useStyles();
  const showDialog = useDialog();
  const history = useHistory();

  return (
    <div
      className={classes.root}
    >
      <LocalizedText>
        impersonating
      </LocalizedText>
      &nbsp;
      <Typography>
        {firstName}
        {' '}
        {lastName}
        {' '}
        (
        {personNumber}
        )
      </Typography>
      {!isLoading ?
        <IconButton
          className={classes.exitButton}
          onClick={() => {
            setIsLoading(true);
            UserService.removeImpersonation()
              .then(() => {
                window.location.reload()
              }).catch(errorMessage => {
                if (errorMessage !== ErrorName.ABORT_ERROR) {
                  showDialog({
                    variant: DialogType.ERROR,
                    title: localize('error'),
                    description: errorMessage
                  });
                  history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: errorMessage });
                }
              });
          }}
        >
          <CustomIcon icon={faTimes} />
        </IconButton>
        :
        <CircularProgress size={20} style={{marginLeft: '10px'}}/>
      }
    </div>
  );
};

export default ImpersonatingUserOverlay;